import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import AlliedCamera from '../assets/troubleshooting/6.7-allied-camera.png';
import AlliedConnections from '../assets/troubleshooting/6.8-camera-connections.png';
import ChannelBoard from '../assets/troubleshooting/6.9-channel-board.png';
import LEDHeader from '../assets/troubleshooting/6.10-LED-header-board.png';
import ArchDoubleWide from '../assets/troubleshooting/6.11-arch-double-wide-LED.png';
// import ArchBoards from '../assets/troubleshooting/6.12-arch-light-boards.png';
// import WideBoards from '../assets/troubleshooting/6.13-LED-wide-light-boards.png';
// import ArchConnecions from '../assets/troubleshooting/6.14-light-arch-connections.png';
// import DoubleWideConnections from '../assets/troubleshooting/6.15-double-wide-connections.png';
import TriggerBoard from '../assets/troubleshooting/6.16-trigger-board-connections.png';
// import ArchHousing from '../assets/troubleshooting/6.17-arch-light-housing.png';
// import DoubleHousing from '../assets/troubleshooting/6.18-double-wide-housing.png';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

const SITroubleshootOverview = () => {
	const [activeKey, setActiveKey] = useState('Electrical Troubleshooting Overview');
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Troubleshooting</Breadcrumb.Item>
							<Breadcrumb.Item active>Hardware Troubleshooting</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs activeKey={activeKey} onSelect={setActiveKey} className="mb-3 troubleshooting-element">
								<Tab eventKey="ALLIED Camera Troubleshooting" title="ALLIED Camera Troubleshooting">
									<div
										class="tab-section"
										style={{
											justifyContent: 'space-between',
											display: 'flex',
										}}
									>
										<div class="left-side" style={{}}>
											<h2>ALLIED CAMERA TROUBLESHOOTING</h2>
											<h5>Manually Cycle Camera Power</h5>
											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Step</th>
														<th>Sequence Description</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>1</td>
														<td>
															Attempt to cycle camera power via the <b>HMI</b> first, if that is unsuccessful move on to step 2.
														</td>
													</tr>
													<tr>
														<td>2</td>
														<td>
															Locate the circuit breakers within the <b>PDP</b> cabinet associated to camera power.
														</td>
													</tr>
													<tr>
														<td>3</td>
														<td>Turn breakers to the off position which will kill power to all of the cameras.</td>
													</tr>
													<tr>
														<td>4</td>
														<td>Wait 1 minute before turning the breakers back on to restore power to the cameras.</td>
													</tr>
													<tr>
														<td>5</td>
														<td>
															To manually ensure power has been restored to the cameras check the status indicator lights on the back of the cameras which now should be illuminated (see <b>Figure 1</b>).
														</td>
													</tr>
												</tbody>
											</Table>
											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Symptom</th>
														<th>Probable Solutions</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td rowSpan={5}>No Camera Power</td>
														<td>
															Check to ensure the camera power cable is securely plugged into the power port on the back of the camera (see <b>Figure 1</b>).
														</td>
													</tr>
													<tr>
														<td>Check all wires from the 24VDC power supply all the way through to the junction boxes (see electrical semantics/prints). Replace any and all wires/cables that are found to be bad or damaged.</td>
													</tr>
													<tr>
														<td>
															Locate the circuit breakers within the <b>PDP</b> cabinet associated to camera power and make sure they are in the on position (see electrical semantics/prints). Check voltage at the circuit breakers with a multimeter, it should read 24VDC. If there is no voltage check the power supply or associated wiring.
														</td>
													</tr>
													<tr>
														<td>
															Check the wires for the camera power cable within the junction box associated with the camera or cameras without power. Ensure that the wires are properly connected and have not come loose or have become damaged. If the wires are ok and properly connected check for power across the associated power and ground terminals/wires, you should have 24VDC. If you HAVE 24VDC on the terminals, plug the camera power cable into a known good camera. If the known good camera does not power up replace the camera power cable. If you do <b>NOT</b> have 24VDC check the associated circuit breakers, wiring and power supplies.
														</td>
													</tr>
													<tr>
														<td>
															Locate and check the 24V power supply located in the <b>PDP</b>, ensure the associated circuit breaker for the power supply is in the on position and has 480VAC incoming, if not check the wiring and replace as needed. Check for 24VDC outgoing at the power supply, the power supply should be set to 24VDC outgoing. If not adjust the power supply to the correct setting of 24VDC. Make sure you are checking the correct power supply as the light power supply is of a higher voltage value (see electrical semantics/prints). If the power supply is not operational replace as necessary.
														</td>
													</tr>
													<tr>
														<td rowSpan={2}>No Camera Data Connection</td>
														<td>Check the CAT6 data cable connections at both ends. Ensure the data cable is securely plugged into the back of the camera and into the associated port on the server within the OP/Operator panel.</td>
													</tr>
													<tr>
														<td>Check the associated CAT6 data cable itself with a communication testing device, replace the CAT6 data cable if it is found to be bad.</td>
													</tr>
													<tr>
														<td rowSpan={3}>Suspected Camera Trigger Problem</td>
														<td>
															Check the camera trigger by using the <b>HMI</b> to trigger the cameras via software (see camera control in the software section). If you are unable to trigger the cameras via the <b>HMI</b> please continue with hardware troubleshooting of the camera trigger cable.
														</td>
													</tr>
													<tr>
														<td>
															Check to ensure the camera power/trigger cable is securely plugged into the power/trigger port on the back of the camera (see <b>Figure 1</b>).
														</td>
													</tr>
													<tr>
														<td>
															Check the wires for the camera trigger cable within the junction box associated with the camera or cameras that will not trigger. Ensure that the wires are properly connected and have not come loose or have become damaged. If the wires are ok and properly connected check for trigger power across the associated power and ground terminals/wires within the junction box. You can use a 9V battery and connect the associated power and ground trigger wires (see electrical schematics/prints) connected to the trigger board block connectors located within the <b>PDP</b> (see <b>Figure 1: Trigger Board Connections/Layout</b>) to the 9V battery. Once the battery is connected on the trigger board side check for the 9V at the terminals where the associated camera trigger cable wires are landed within the junction box. If you have 9V at the terminals within the junction box the wiring to the junction box from the trigger board is ok. Check the camera power/trigger cable from the junction box to the camera. Reconnect the trigger wires removed from the trigger board block connector and command the camera trigger via the <b>HMI</b>. If you HAD 9V on the terminals within the junction box, plug the camera power cable/trigger cable into a known good camera. If the known good camera does not trigger when commanded via the <b>HMI</b> replace the camera power/trigger cable. If the known good camera does trigger when commanded via the <b>HMI</b> replace the bad camera (see Camera Replacement in Section 5 - Maintenance). If you do <b>NOT</b> have 9V at the terminals within the junction box replace the associated wiring from the trigger board to the junction box.
														</td>
													</tr>
												</tbody>
											</Table>
										</div>
										<div class="right-side">
											<figure>
												<img
													src={AlliedCamera}
													alt="Master Key Box"
													style={{
														width: '25vw',
														margin: '20px',
													}}
												/>
												<figcaption>Figure 1: ALLIED Camera Overview</figcaption>
											</figure>
											<figure>
												<img
													src={AlliedConnections}
													alt="Master Key Box"
													style={{
														width: '25vw',
														margin: '20px',
													}}
												/>
												<figcaption>Figure 2: ALLIED Camera Connections</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="No LED / Channel Board Power" title="No LED / Channel Board Power">
									<div
										class="tab-section"
										style={{
											justifyContent: 'space-between',
											display: 'flex',
										}}
									>
										<div class="left-side" style={{}}>
											<h2>NO LED LIGHT / CHANNEL BOARD POWER</h2>

											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Probable Solutions</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															Check to ensure the LED power cable is securely plugged into the power port on the bulkhead of the associated light box (see <b>Figure 1: Channel Board Connections</b>
															).
														</td>
													</tr>
													<tr>
														<td>
															Check the 3.15 amp glass fuse on the associated channel board within the light box and ensure it is not blown by using a multi-meter to check continuity across the fuse (see <b>Figure 1: Channel Board Connections</b>
															). If the fuse is blown replace as necessary and check wiring for damage or short circuits. If the fuse is ok check the voltage, wiring, power cables, connections and power supplies.
														</td>
													</tr>
													<tr>
														<td>Check all wires to and from the 27.2VDC power supply all the way through the junction boxes to the channel boards (see electrical semantics/prints). Replace any and all wires/cables that are found to be bad or damaged.</td>
													</tr>
													<tr>
														<td>Locate the circuit breakers within the PUSHBUTTONS cabinet associated to LED light power and make sure they are in the on position (see electrical schematics/prints). Check voltage at the circuit breakers with a multi-meter, it should read 120VAC. If there is no voltage check the power supply or associated wiring.</td>
													</tr>
													<tr>
														<td>
															Check the wires for the LED light power cable within the junction box associated with the light or lights without power. Ensure that the wires are properly connected and have not come loose or have become damaged. If the wires are ok and properly connected check for power across the associated power and ground terminals/wires, you should have 27.2VDC. If you HAVE 27.2VDC on the terminals ensure there is power to the channel board power connector located on the channel board within the associated light box. If the channel board does <b>NOT</b> show 27.2VDC across the power connector replace the LED light power cable. If you do <b>NOT</b> have 27.2VDC at the terminals within the junction box check the associated circuit breakers, wiring and power supplies to the junction box.
														</td>
													</tr>
													<tr>
														<td>Locate and check the 27.2VDC power supply or supplies located by the light box, ensure the associated circuit breaker for the power supply is in the on position and has 120VAC incoming, if not check the wiring and replace as needed. Check for 27.2VDC outgoing at the power supply, the power supply should be set to 27.2VDC outgoing. If not adjust the power supply to the correct setting of 27.2VDC. Make sure you are checking the correct power supply as the camera power supply is of a lower voltage value (see electrical schematics/prints). If the power supply is not operational replace as necessary.</td>
													</tr>
													<tr>
														<td>
															If you have 27.2VDC at the channel board power connector (see <b>Figure 1: Channel Board Connections</b>) and the light will not come on/trigger please ensure the power cable from the channel board to the LED light header board is connected on the channel board and the LED light header board (see Figure 1: LED Header Board Connections).
														</td>
													</tr>
													<tr>
														<td>
															If you have 27.2VDC at the channel board power connector (see <b>Figure 1: Channel Board Connections</b>) and the light will not come on/trigger please see the trigger board troubleshooting portion of this section.
														</td>
													</tr>
												</tbody>
											</Table>
										</div>

										<div class="right-side">
											<figure>
												<img
													src={ChannelBoard}
													alt="Master Key Box"
													style={{
														width: '30vw',
														margin: '20px',
													}}
												/>
												<figcaption>Figure 1: Channel Board Connections</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="LED Board Not Illuminated" title="LED Board Not Illuminated">
									<div
										class="tab-section"
										style={{
											justifyContent: 'space-between',
											display: 'BLOCK',
										}}
									>
										<div class="left-side" style={{}}>
											<h2>LED BOARD NOT ILLUMINATED</h2>

											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Probable Solutions</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>Check the LED lights by using the HMI to trigger the lights on and off via software to determine which light segment needs to be inspected (see light control in the software section). If you are unable to trigger the lights on and off via the HMI please continue with hardware troubleshooting of the LED light power and or LED light trigger problems.</td>
													</tr>
													<tr>
														<td>Check the connection on the back of the LED light header board to ensure they are securely in place.</td>
													</tr>
													<tr>
														<td>
															Check connections between the board segments to ensure they are not damaged (see <b>Figure 1, Figure 2</b>). Replace LED board segment if damage is found (see LED board replacement in <a href="/smart-inspect/warren/maintenance/maintenance-procedures">Maintenance Procedures</a>).
														</td>
													</tr>
												</tbody>
											</Table>
										</div>

										<div class="right-side d-flex">
											<figure>
												<img
													src={LEDHeader}
													alt="Master Key Box"
													style={{
														width: '30vw',
														margin: '20px',
													}}
												/>
												<figcaption>Figure 1: LED Header Board Connections</figcaption>
											</figure>
											<figure>
												<img
													src={ArchDoubleWide}
													alt="Master Key Box"
													style={{
														width: '30vw',
														margin: '20px',
													}}
												/>
												<figcaption>Figure 2: Arch/Double Wide LED Light Assemblies</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Suspected LED Trigger Problem" title="Suspected LED Trigger Problem">
									<div
										class="tab-section"
										style={{
											justifyContent: 'space-between',
											display: 'flex',
										}}
									>
										<div class="left-side" style={{}}>
											<h2>SUSPECTED LED LIGHT TRIGGER PROBLEM</h2>

											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Probable Solutions</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															Check the LED lights by using the <b>HMI</b> to trigger the lights on and off via software (see light control in the software section). If you are unable to trigger the lights on and off via the <b>HMI</b> please continue with hardware troubleshooting of the LED light power and or LED light trigger problems.
														</td>
													</tr>
													<tr>
														<td>
															Check to ensure the LED trigger cable is securely plugged into the trigger port on the bulkhead of the associated light box (see <b>Figure 1: Channel Board Connections</b>).
														</td>
													</tr>
													<tr>
														<td>
															Check the wires for the light trigger cable within the junction box associated with the light or lights that will not trigger. Ensure that the wires are properly connected and have not come loose or have become damaged. If the wires are ok and properly connected check for trigger power across the associated power and ground terminals/wires within the junction box. You can use a 9V battery and connect the associated power and ground trigger wires (see electrical schematics/prints) connected to the trigger board block connectors located within the TP1/2 (see <b>Figure 2: Trigger Board Connections</b>) to the 9V battery. Once the battery is connected on the trigger board side check for the 9V at the terminals where the associated light trigger cable wires are landed within the junction box. If you have 9V at the terminals within the junction box the wiring to the junction box from the trigger board is ok. Check the light trigger cable from the junction box to the light box/channel board trigger connector on the channel board (see <b>Figure 1: Channel Board Connections</b>) you should have 9V across the connector. If you have 9V at the channel board trigger connector the trigger cable is ok. Check the 3.15amp glass fuse and ensure the channel board has power (see No LED Light/Channel Board Power in this section). If the power/fuse to the channel board is ok and you have 9V at the channel board trigger connector check the power wires to the LED board header. Reconnect the trigger wires removed from the trigger board block connector. If you do <b>NOT</b> have 9V at the terminals within the junction box replace the associated wiring from the trigger board to the junction box. If all power and trigger wiring/cables to the channel board/LED header were ok replace channel board.
														</td>
													</tr>
												</tbody>
											</Table>
										</div>

										<div class="right-side">
											<figure>
												<img
													src={ChannelBoard}
													alt="Master Key Box"
													style={{
														width: '30vw',
														margin: '20px',
													}}
												/>
												<figcaption>Figure 1: Channel Board Connections</figcaption>
											</figure>

											<figure>
												<img
													src={TriggerBoard}
													alt="Master Key Box"
													style={{
														width: '30vw',
														margin: '20px',
													}}
												/>
												<figcaption>Figure 2: Trigger Board Connections</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="No Trigger Board Power" title="No Trigger Board Power">
									<div
										class="tab-section"
										style={{
											justifyContent: 'space-between',
											display: 'flex',
										}}
									>
										<div class="left-side" style={{}}>
											<h2>LED BOARD NOT ILLUMINATED</h2>

											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Probable Solutions</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															Check to ensure the trigger board power connector is securely plugged into the power port on the trigger board and that the on/off switch is ON in the down position (see <b>Figure 1: Trigger Board Connections</b>).
														</td>
													</tr>
													<tr>
														<td>Check all wires from the 24VDC power supply all the way through to the trigger board connector (see electrical semantics/prints). Replace any and all wires/cables that are found to be bad or damaged.</td>
													</tr>
													<tr>
														<td>Locate the circuit breakers within the PUSHBUTTONS cabinet associated to trigger board power and make sure they are in the on position (see electrical semantics/prints). Check voltage at the circuit breaker with a multi-meter, it should read 24VDC. If there is no voltage check the power supply or associated wiring.</td>
													</tr>
													<tr>
														<td>Locate and check the 24V power supply located in the PUSHBUTTONS, ensure the associated circuit breaker for the power supply is in the on position and has 480VAC incoming, if not check the wiring and replace as needed. Check for 24VDC outgoing at the power supply, the power supply should be set to 24VDC outgoing. If not adjust the power supply to the correct setting of 24VDC. Make sure you are checking the correct power supply as the light power supply is of a higher voltage value (see electrical semantics/prints). If the power supply is not operational replace as necessary.</td>
													</tr>
												</tbody>
											</Table>
										</div>

										<div class="right-side">
											<figure>
												<img
													src={TriggerBoard}
													alt="Master Key Box"
													style={{
														width: '30vw',
														margin: '20px',
													}}
												/>
												<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Suspected Encoder Signal Problem" title="Suspected Encoder Signal Problem">
									<div
										class="tab-section"
										style={{
											justifyContent: 'space-between',
											display: 'flex',
										}}
									>
										<div class="left-side" style={{}}>
											<h2>LED BOARD NOT ILLUMINATED</h2>

											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Probable Solutions</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															Check the <b>HMI</b> overview screen for encoder values, if the encoder values are blank check the encoder signal wires (see electrical schematics/prints) located on the trigger board block connector X5/X6 (see <b>Figure 1: Trigger Board Connections</b>) within the TP1.
														</td>
													</tr>
													<tr>
														<td>
															Use a multi-meter and check for the A+B, 5V signals from the encoder. If there is no signal/voltage from the encoder at the trigger board check the wiring back to the terminal block within the OP/operator panel. If there is no signal at the terminal block within the OP/operator panel check the encoder 5V power supply located in the <b>PDP</b>. If the 5V power supply and wiring are ok check/replace encoder.
														</td>
													</tr>
												</tbody>
											</Table>
										</div>

										<div class="right-side">
											<figure>
												<img
													src={TriggerBoard}
													alt="Master Key Box"
													style={{
														width: '30vw',
														margin: '20px',
													}}
												/>
												<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Suspected Part Detect Signal Problem" title="Suspected Part Detect Signal Problem">
									<div
										class="tab-section"
										style={{
											justifyContent: 'space-between',
											display: 'flex',
										}}
									>
										<div class="left-side" style={{}}>
											<h2>LED BOARD NOT ILLUMINATED</h2>

											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Probable Solutions</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															Check the <b>HMI</b> overview screen for the part detect signal, if the detect signal is missing check the part detect signal wires (see electrical schematics/prints) located on the trigger board block connector X5/X6 (see <b>Figure 1: Trigger Board Connections</b>) within the TP.
														</td>
													</tr>
													<tr>
														<td>
															Use a multi-meter and check for the signal from the part detect. If there is no signal/voltage from the part detect at the trigger board check the wiring back to the terminal block within the PUSHBUTTONS. If there is no signal at the terminal block within the <b>PDP</b> check the part detect cable and power running to the part detect switch from the PUSHBUTTONS replace if necessary. If the part detect cable is ok check/replacement of the part detect switch may be necessary.
														</td>
													</tr>
												</tbody>
											</Table>
										</div>

										<div class="right-side">
											<figure style={{ width: '30vw', margin: '20px' }}>
												<img src={TriggerBoard} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
											</figure>
										</div>
									</div>
								</Tab>
								<Tab eventKey="Suspected Laser Photoeye Signal Problem" title="Suspected Laser Photoeye Signal Problem">
									<div
										class="tab-section"
										style={{
											justifyContent: 'space-between',
											display: 'flex',
										}}
									>
										<div class="left-side" style={{}}>
											<h2>LED BOARD NOT ILLUMINATED</h2>

											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Probable Solutions</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															Check the <b>HMI</b> overview screen for the photo eye signal, if the photo eye signal is missing check the photo eye signal wires (see electrical schematics/prints) located on the trigger board block connector X5/X6 (see <b>Figure 1: Trigger Board Connections</b>) within the PUSHBUTTONS.
														</td>
													</tr>
													<tr>
														<td>
															Use a multi-meter and check for the signal from the photo eye. If there is no signal/voltage from the photo eye at the trigger board check the wiring back to the terminal block within the PUSHBUTTONS for signal/power. If there is no signal/power at the terminal block within the <b>PDP</b> check the photo eye wiring/cable running to the photo eye from the PUSHBUTTONS replace if necessary. If the photo eye cable is ok check the photo eye and ensure the laser is aligned to the reflector. If so, replacement of the photo eye may be necessary.
														</td>
													</tr>
												</tbody>
											</Table>
										</div>

										<div class="right-side">
											<figure>
												<img
													src={TriggerBoard}
													alt="Master Key Box"
													style={{
														width: '30vw',
														margin: '20px',
													}}
												/>
												<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
											</figure>
										</div>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SITroubleshootOverview;
